// src/data/accordion.js

import rocket_img from "@/assets/Icon/Rocket.png";
import mail_img from "@/assets/Icon/Mail.png";
import ci_b_img from "@/assets/CI/B.png";
import ci_e_img from "@/assets/CI/E.png";
import ci_p_img from "@/assets/CI/P.png";
import BTBImg from "@/assets/Icon/Btb.png";
import SpinOutCatsImg from "@/assets/Icon/SpinOutCats_AppIcon.jpg";
import EnigmaImg from "@/assets/Icon/Enigma_AppIcon.webp";
export const accordion = [
  {
    nameKey: "Header.Category.About",
    content: [
      { nameKey: "Header.Detail.About.Info", url: "about/aboutus" },
      { nameKey: "Header.Detail.About.History", url: "about/history" },
      { nameKey: "Header.Detail.About.Value", url: "about/vision" },
    ],
  },
  {
    nameKey: "Header.Category.Games",
    content: [
      { nameKey: "Header.Detail.Games.Btb", open_url: "https://linktr.ee/Beat.The.Beat" },
      {
        nameKey: "Header.Detail.Games.SpinOutCats",
        google_store_url: "https://play.google.com/store/apps/details?id=com.BePex.SpinMeowt&hl=ko",
        apple_store_url: "https://apps.apple.com/be/app/%EB%8F%8C%EC%95%84%EB%B2%84%EB%A0%B8%EB%83%A5-%EA%B3%A0%EC%96%91%EC%9D%B4-%EB%94%94%ED%8E%9C%EC%8A%A4/id6761755572?l=nl",
      },
      { nameKey: "Header.Detail.Games.Enigma", open_url: "https://linktr.ee/davncicode_enigma" },
    ],
  },
  {
    nameKey: "Header.Category.News",
    content: [
      { nameKey: "Header.Detail.News.Articles", url: "news/newspress" },
      { nameKey: "Header.Detail.News.Media", url: "news/media" },
    ],
  },
  {
    nameKey: "Header.Category.Careers",
    content: [
      { nameKey: "Header.Detail.Careers.Recruit", url: "careers/home" },
      { nameKey: "Header.Detail.Careers.Faq", url: "careers/faq" },
    ],
  },
  {
    nameKey: "Header.Category.ContactUs",
    content: [{ nameKey: "Header.Detail.ContactUs.Suggestion", url: "contact-us" }],
  },
];



export const storeData = [
  {
    nameKey: "ServiceCenter.Link.BeatTheBeat",
    img_url: "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/e3/aa/25/e3aa255f-110a-b65e-8cd3-1b3010664db7/AppIcon-1x_U007emarketing-0-8-0-85-220-0.png/230x0w.webp",
    url: "https://play.google.com/store/apps/details?id=com.BePex.beatthebeat&hl=en_US",
  },
  {

    nameKey: "ServiceCenter.Link.BeatTheBeat",
    img_url: "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/e3/aa/25/e3aa255f-110a-b65e-8cd3-1b3010664db7/AppIcon-1x_U007emarketing-0-8-0-85-220-0.png/230x0w.webp",
    url: "https://apps.apple.com/sg/app/beat-the-beat-rhythm-action/id6444065575",
  },
  {

    nameKey: "Header.Detail.Games.SpinOutCats",
    img_url: SpinOutCatsImg,
    url: "https://play.google.com/store/apps/details?id=com.BePex.SpinMeowt&hl=ko",
  },
  {
    nameKey: "Header.Detail.Games.SpinOutCats",
    img_url: SpinOutCatsImg,
    url: "https://apps.apple.com/be/app/%EB%8F%8C%EC%95%84%EB%B2%84%EB%A0%B8%EB%83%A5-%EA%B3%A0%EC%96%91%EC%9D%B4-%EB%94%94%ED%8E%9C%EC%8A%A4/id6761755572?l=nl",
  },
  {

    nameKey: "ServiceCenter.Link.Enigma",
    img_url: "https://play-lh.googleusercontent.com/vQwW6XTjGyqaBkX2LfIvdCoAqVS447Nut_Ue0HDEMvNA_sN6oz99QNxPKpByZLgjnNQ=w240-h480-rw",
    url: "https://play.google.com/store/apps/details?id=com.softmarshmallow.enigma&hl=en_US",
  },
  {
    nameKey: "ServiceCenter.Link.Enigma",
    img_url: "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/16/7d/ef/167def85-bc82-f044-5c9d-fa998027ab19/AppIcon-1x_U007emarketing-0-7-0-85-220-0.png/230x0w.webp",
    url: "https://apps.apple.com/kr/app/%EB%8B%A4%EB%B9%88%EC%B9%98%EC%BD%94%EB%93%9C-enigma/id1191078827",
  }
]
export const homepageData = {
  "OurProject": [
    {
      img_url: BTBImg,
      open_url: accordion[1].content[0].open_url,
      google_store_url : storeData[0].url,
      apple_store_url : storeData[1].url,
      descriptionKey:"Home.BTB.Description",
      nameKey: storeData[1].nameKey
    },
    {
      img_url: SpinOutCatsImg,
      google_store_url : storeData[2].url,
      apple_store_url : storeData[3].url,
      nameKey: storeData[3].nameKey
    },
    {
      img_url: EnigmaImg,

      google_store_url : storeData[4].url,
      apple_store_url : storeData[5].url,
      descriptionKey:"Home.Enigma.Description",
      open_url: accordion[1].content[2].open_url,
      nameKey: storeData[5].nameKey
    }
  ],
  "Join": [
    {
      img_url: rocket_img,
      titleKey: "Home.Join.BePex.Title",
      descriptionKey: "Home.Meida.Description2",
      btn_textKey: "Home.Join.BePex.ButtonText",
      url: accordion[3].content[0].url
    },
    {

      img_url: mail_img,
      titleKey: "Home.Join.Contact.Title",
      descriptionKey: "Home.Join.Contact.Descriptoin",
      btn_textKey: "Header.Category.ContactUs",
      url: accordion[4].content[0].url
    }
  ],
  "Media": [
    {
      video_url: "/Media/Media1.mp4",
      titleKey: "Header.Detail.About.Info",
      descriptionKey: "Home.Meida.Description1",
      url: accordion[0].content[0].url
    },
    {
      video_url: "/Media/Media2.mp4",
      titleKey: "Header.Category.Careers",
      descriptionKey: "Home.Meida.Description2",
      url: accordion[3].content[0].url
    }
  ]
}


export const visionData = {
  Core: [
    {
      titleKey: "Vision.Core.Colum1.Title",
      highlightKey: "Vision.Core.Colum1.Highlight",
      descriptionKey: "Vision.Core.Colum1.Description"
    },

    {
      titleKey: "Vision.Core.Colum2.Title",
      highlightKey: "Vision.Core.Colum2.Highlight",
      descriptionKey: "Vision.Core.Colum2.Description"
    },

    {
      titleKey: "Vision.Core.Colum3.Title",
      highlightKey: "Vision.Core.Colum3.Highlight",
      descriptionKey: "Vision.Core.Colum3.Description"
    }
  ],
  CI: [
    {
      titleKey: "Vision.CI.B.Title",
      descriptionKey: "Vision.CI.B.Description",
      img_url: ci_b_img
    },
    {
      titleKey: "Vision.CI.E.Title",
      descriptionKey: "Vision.CI.E.Description",
      img_url: ci_e_img
    },
    {
      titleKey: "Vision.CI.P.Title",
      descriptionKey: "Vision.CI.P.Description",
      img_url: ci_p_img
    }
  ]
}
export const OnOpenUrl = ({ content,navigate: router }) => {
  if (content.google_store_url && content.apple_store_url) {
    const isApplePlatform = /iPhone|iPad|iPod|Macintosh/i.test(navigator.userAgent);
    const storeUrl = isApplePlatform ? content.apple_store_url : content.google_store_url;

    window.open(storeUrl, "_blank", "noopener,noreferrer");
  } else if (content.open_url) {
    window.open(content.open_url, "_blank", "noopener,noreferrer");
  } else if (content.url.includes("http")) {
    window.open(content.url, "_blank", "noopener,noreferrer");
  } else {
    router.push(`/${content.url}`);
  }
}
export const OnPreFetchUrl = ({content, navigate:router}) => {
  if (content.google_store_url && content.apple_store_url) {
  } else if (content.open_url) {
  } else if (content.url.includes("http")) {
  } else {
    router.prefetch(`/${content.url}`);
  }
}
